import React from "react";
import FormElement from "./FormElement";

class Input extends FormElement {
    multiColumn = false;
    placeHolder = "";

    render() {
        let componentClasses = [
            this.props.multiColumn ? "form-group" : "input-group",
            this.props.className || "mb-2",
        ];

        if (this.state.isValid === false) {
            componentClasses.push("error");
        }

        let icon = "";
        if (this.props.icon) {
            componentClasses.push("icon");
            icon = <i className={this.props.icon} />
        }

        let component =
            <div className={componentClasses.join(" ")}>
                <div className={"input-group-prepend"}/>
                {icon}
                <input name={this.props.name}
                       className={"form-control"}
                       id={this.props.name}
                       onChange={(e) => {
                           this.checkValid(e);
                           this.props.handleChange(e);
                       }}
                       value={this.props.value}
                       required={this.props.required}
                       pattern={this.props.pattern}
                       type={this.props.type || "text"}
                />
                <label className={"form-label"}>{this.props.placeHolder}</label>
            </div>
        ;

        if (this.props.multiColumn) {
            return (
                component
            );
        }

        return (
            <div className="form-group">
                {component}
            </div>
        );
    }
}

export default Input;


